import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { School } from '@global/utils/SchoolService';
import { CommonSelect } from '@src/global/components/common/CommonSelect';

const SCHOOL_SELECT_ID = 'card_billingaddress_state';
const SCHOOL_VALUE_KEY = 'schoolFiceId';
const SCHOOL_LABEL_KEY = 'schoolName';
const SCHOOL_ID_KEY = 'schoolFiceId';

interface SelectSchoolInputProps {
  schools: School[];
  fieldName: string;
  placeholder: string;
  disabled?: boolean;
}

export const SelectSchoolInput = ({
  schools,
  fieldName,
  disabled,
  placeholder,
}: SelectSchoolInputProps) => {
  const { t } = useTranslation();

  const { field: schoolField, fieldState } = useController({
    name: fieldName,
  });

  return (
    <CommonSelect
      label={t('activeForm.schoolSelect')}
      id={SCHOOL_SELECT_ID}
      options={schools}
      onChange={schoolField.onChange}
      itemValue={SCHOOL_VALUE_KEY}
      itemLabel={SCHOOL_LABEL_KEY}
      itemId={SCHOOL_ID_KEY}
      disabled={disabled}
      placeholder={placeholder}
      value={schoolField.value}
      defaultOption={t('checkout.schoolStep.noSchoolSelected')}
      isValid={schoolField.value && !fieldState.error}
      error={!!fieldState.error}
      errorMessage={fieldState.error?.message}
    />
  );
};
